import React from 'react';
import { compose, pure } from 'recompose';
import { Button, Modal } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';

type Props = {
  showcaseTitle: string,
  show: boolean,
  onHide: () => void,
  onRemoveShowcaseClick: () => void,
  showcaseStatus: string
}

const ShowcaseRemoveModal = ({
  showcaseTitle,
  show,
  onHide,
  onRemoveShowcaseClick,
  showcaseStatus,
}: Props) => {
  const removeAndHide = () => {
    onRemoveShowcaseClick();
    onHide();
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
        Remove Project
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to remove the <strong>{`"${showcaseTitle}"`}</strong> project?</p>
        <p><strong>Note:</strong> This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          id="remove-project-cancel-button"
          onClick={onHide}
          bsSize="small"
          flat
        >
        Cancel
        </Button>
        <Track>
          <Button
            id="remove-project-confirm-button"
            data-track-activity-location={`SP : My Business : Showcase ${showcaseStatus === 'Published' ? 'Published' : 'Drafts'}`}
            bsStyle="danger"
            bsSize="small"
            flat
            type="submit"
            onClick={removeAndHide}
          >
          Remove Project
          </Button>
        </Track>
      </Modal.Footer>
    </Modal>
  );
};

export default compose(pure)(ShowcaseRemoveModal);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ShowcaseRemoveModal.js